<template>
  <div>

<h2 class="goth">Imperfekt av svaga verb</h2>
<div class="grammatikparagrafbredd leftorient">
<h4>Vad är imperfekt</h4>
          <p>Imperfekt är en tidsform som uttrycker dåtid med en egen verbform utan att använda hjälpverb,
              både i tyskan och i svenskan. </p>
              <p>Exempel:</p>
              <p>infinitiv: <i>spielen, wohnen</i><br>imperfekt: <i>spielte, wohnte</i>.</p>
              <p>infinitiv: <i>spela, bo</i><br>imperfekt: <i>spelade, bodde</i>.</p>

              <p>I svenskan är imperfekt den vanligaste
              formen för att uttrycka dåtid, medan imperfekt i tyskan mest förekommer i skriftspråk
              (i tyskt talspråk används oftare perfekt).</p><br>

              <br><h4>Imperfekt av svaga verb</h4>


              <div class="quasi-p p-stil">I tyska <div class="understryk">svaga verb</div> bildas <div class="understryk">imperfekt</div> med
              <div class="understryk"><nobr> [verbstam] + <b>te </b> + imperfektändelser</nobr></div>.
                  Ändelserna <b><i>-st, -n, -t </i></b>för olika person imperfekt är lika dem som används i presens,
                  men de är inte exakt samma.  i 1:a och 3:e person i singular används
                  ingen personändelse. I 1:a och 3:e person plural blir personändelserna
                  endast <i><b>–n</b></i> (ett <i>e</i> finns där redan).</div>


                  <br><br>
                  <p class="grammatikparagrafbredd leftorient">Exempel på imperfekt med verbet <i>spielen</i></p>


                  <table class="">
                  <br>

                  <tr class="leftorient">
                    <td class="ljusgra">ich</td>
                    <td class="ljusgra"><i>spiel<b><div class="accented">te</div></b></i></td>
                  </tr>

                  <tr class="leftorient">
                    <td class="ljusgra">du</td>
                    <td class="ljusgra"><i>spiel<b><div class="accented">te</div>st</b></i></td>
                  </tr>

                  <tr class="leftorient">
                    <td class="ljusgra">er<br> es<br> sie</td>
                    <td class="ljusgra"><i>spiel<b><div class="accented">te</div></b></i></td>
                  </tr>

                  <tr class="leftorient">
                    <td class="ljusgra upperspace">wir</td>
                    <td class="ljusgra"><i>spiel<b><div class="accented">te</div>n</b></i></td>
                  </tr>

                  <tr class="leftorient">
                    <td class="ljusgra">ihr</td>
                    <td class="ljusgra"><i>spiel<b><div class="accented">te</div>t</b></i></td>
                  </tr>

                  <tr class="leftorient">
                    <td class="ljusgra">sie<br> Sie</td>
                    <td class="ljusgra"><i>spiel<b><div class="accented">te</div>n</b></i></td>
                  </tr>


                  </table>
<br>
                <div class="inte-minitext">
                <br><br><p class="grammatikparagrafbredd leftorient">I bland skjuts <b>-e-</b> in mellan
                    stammen och imperfekttillägget <b>-te</b> stammen slutar på en konsonant, som gör att ordet annars skulle bli
                  svårt att uttala.</p>
                  <br>
                  <p class="grammatikparagrafbredd leftorient">Ett exempel på ett sådant ord är <i>arbeit</i>|<i>en</i></p>
                  <br>
                  <table class="">


                    <tr class="leftorient">
                        <td class="ljusgra">ich</td>
                        <td  class="ljusgra"><i>arbeit<b>e<div class="accented">te</div></b></i></td>
                    </tr>

                    <tr class="leftorient">
                        <td  class="ljusgra">du</td>
                        <td  class="ljusgra"><i>arbeit<b>e<div class="accented">te</div>st</b></i></td>
                    </tr>

                    <tr class="leftorient">
                        <td  class="ljusgra">er<br> es<br> sie</td>
                        <td  class="ljusgra"><i>arbeit<b>e<div class="accented">te</div></b></i></td>
                    </tr>

                    <tr class="leftorient">
                        <td  class="ljusgra upperspace">wir</td>
                        <td  class="ljusgra"><i>arbeit<b>e<div class="accented">te</div>n</b></i></td>
                    </tr>

                    <tr class="leftorient">
                        <td  class="ljusgra">ihr</td>
                        <td  class="ljusgra"><i>arbeit<b>e<div class="accented">te</div>t</b></i></td>
                    </tr>

                    <tr class="leftorient">
                        <td  class="ljusgra">sie<br> Sie</td>
                        <td  class="ljusgra"><i>arbeit<b>e<div class="accented">te</div>n</b></i></td>
                    </tr>

                  </table>
              </div>


<br><br>
<p>Ordföljden i imperfekt är likadan som i presens.</p>




</div>

<br>
</div>


</template>

<script>
export default {
  name: 'Grammatik',
  props: {
    msg: String
},
metaInfo() {
    return {
        meta: [
            {
                vmid: "description",
                name: "description",
                content: "imperfekt svaga verb"
            }
        ]
    }
},
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
